module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library2-edea13046b06ea239603ca4644d14ef7.svg";